import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {Layout, Select, Input} from "antd";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../../api/http-post";
import {fetchDataEntity} from "../../../../api/entity-data";
import {SortData} from "../../../../api/fn";
import moment from "moment";

const {TextArea} = Input;
const {Content} = Layout;
const {Option} = Select;

class SettingInvoiceLabourVaccinationPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Products: [],
            Periods:[],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");
        await this.loadData("TermsPayCycle", "Periods");
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getModuleList = () => {
        let ls = [];
        for (let i in this.state.Modules) {
            let row = this.state.Modules[i];
            if (row.org === this.state.newEntry.org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    formatDate = (dateIn) => {
        return moment(dateIn, "YYYY-MM-DD").format("DD MMM YYYY");
    }
    getPeriodList = () => {
        let data = this.state.Periods;
        data = SortData("period", data)
        let ls = [];
        for (let i in data) {
            let row = data[i];
            if (row.org === this.state.newEntry.org && row.ref===this.state.newEntry.project) {
                const key = row.startdate + "#" + row.enddate + "#" + row.period+"#"+row.paydate;
                const display = row.period + ". -> Start: " + this.formatDate(row.startdate) + " -> End: " + this.formatDate(row.enddate) +
                    " -> Pay date: " + this.formatDate(row.paydate);
                ls.push({
                    key: key,
                    val: display
                });
            }
        }


        return ls;
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }

    render() {
        const modulesOptions = this.getModuleList();
        const companyOptions = this.getCompanyList();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Invoice Vaccination Info</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"InvoiceVaccinationTools"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "project",
                                    dataType: "option",
                                    required: true,
                                    label: "Project & Contract",
                                    options: modulesOptions,
                                },
                                {
                                    name: "period",
                                    dataType: "option",
                                    required: true,
                                    label: "Period",
                                    options: this.getPeriodList(),
                                    displayList:false,
                                },

                                {
                                    name: "period",
                                    dataType: "string",
                                    required: true,
                                    label: "Period",
                                    options: [],
                                    formEntry:false,
                                },


                                {
                                    name: "item",
                                    dataType: "option",
                                    required: true,
                                    label: "Line Item",
                                    options: [
                                        {key:"Vaccination",val:"Vaccination"},
                                        {key:"Tools",val:"Tools"},
                                        {key:"PPE Material",val:"PPE Material"},
                                    ]
                                },
                                {
                                    name: "quantity",
                                    dataType: "float",
                                    required: true,
                                    label: "Quantity",
                                    options: []
                                },
                                {
                                    name: "unitprice",
                                    dataType: "float",
                                    required: true,
                                    label: "Unit Rate",
                                    options: []
                                },
                                {
                                    name: "total",
                                    dataType: "float",
                                    required: true,
                                    label: "Amount Exd. Vat",
                                    options: []
                                },

                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "project", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"InvoiceVaccinationTools"}
                            addFormText={"Invoice Vaccination Setup"}
                            stepTitle={"Set Up new vaccination info"}
                            filterByCompany={true}
                            filterByModule={true}
                            filterCompanyField={"org"}
                            filterProjectField={"project"}

                        />

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(SettingInvoiceLabourVaccinationPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

